/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Security_User_Api_Key_Add_No_ExpirationInputs */



/**
* | output |
* | --- |
* | "No expiration" |
*
* @param {Profile_Security_User_Api_Key_Add_No_ExpirationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_security_user_api_key_add_no_expiration = /** @type {((inputs?: Profile_Security_User_Api_Key_Add_No_ExpirationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Security_User_Api_Key_Add_No_ExpirationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Kein Ablaufdatum")
	return /** @type {LocalizedString} */ ("No expiration")
});